import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Home, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Alice Bot</title>
        <meta name="description" content="The page you are looking for does not exist." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 pt-20">
        <div className="bg-emerald-main/10 p-6 rounded-full mb-8 animate-pulse">
          <AlertTriangle className="w-16 h-16 text-emerald-main" />
        </div>
        
        <h1 className="font-outfit text-5xl md:text-7xl font-bold mb-4">
          4<span className="text-emerald-main">0</span>4
        </h1>
        
        <h2 className="font-outfit text-2xl md:text-3xl font-semibold mb-6">
          Page Not Found
        </h2>
        
        <p className="text-gray-400 max-w-md mb-8 text-lg">
          Oops! The page you're looking for seems to have wandered off into the digital void.
        </p>
        
        <Link to="/">
          <Button className="bg-emerald-main hover:bg-emerald-light text-black font-bold rounded-full px-8 py-6 flex items-center gap-2 transition-transform hover:scale-105">
            <Home className="w-5 h-5" />
            Back to Home
          </Button>
        </Link>
      </div>
    </>
  );
};

export default NotFound;
